const cards = [
  {
    title: '本周必看：科幻巨制',
    desc: '星河纪元系列最新作重磅上线，视觉奇观与深度剧情兼得，年度科幻电影不可错过。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20image%20of%20a%20futuristic%20space%20explorer%20silhouette%20against%20a%20nebula%20backdrop%2C%20deep%20space%20colors%20with%20golden%20light%20rays%2C%20epic%20scale%2C%20film%20grain%20texture%2C%20dramatic%20composition%2C%20dark%20background%20with%20star%20particles&width=600&height=800&seq=card-01&orientation=portrait',
    tag: '科幻',
  },
  {
    title: '悬疑推荐：反转神作',
    desc: '年度最烧脑悬疑片，五重反转让你猜不到结局，演技炸裂氛围拉满。',
    img: 'https://readdy.ai/api/search-image?query=Moody%20film%20noir%20poster%20with%20a%20shadowy%20figure%20standing%20under%20a%20street%20lamp%20in%20rain%2C%20venetian%20blind%20shadow%20patterns%2C%20deep%20contrast%20black%20and%20warm%20amber%2C%20mysterious%20atmosphere%2C%20cinematic%20grain%2C%20dramatic%20lighting&width=600&height=800&seq=card-02&orientation=portrait',
    tag: '悬疑',
  },
  {
    title: '国漫新作：视觉盛宴',
    desc: '国产动画电影再攀高峰，东方水墨美学与现代CG完美融合，感动千万观众。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20creature%20in%20ink%20wash%20painting%20style%2C%20flowing%20silk%20ribbons%2C%20ethereal%20mist%20and%20golden%20light%2C%20traditional%20oriental%20art%20aesthetic%20blended%20with%20modern%20digital%20art%2C%20cinematic%20composition%2C%20jade%20and%20amber%20tones&width=600&height=800&seq=card-03&orientation=portrait',
    tag: '动画',
  },
  {
    title: '经典重温：岁月留声',
    desc: '4K修复版经典影片系列，在超清画质中重新感受那些感动一代人的银幕时刻。',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20film%20camera%20and%20old%20movie%20posters%20in%20warm%20nostalgic%20lighting%2C%20retro%20cinema%20aesthetic%2C%20aged%20paper%20textures%2C%20golden%20hour%20glow%2C%20art%20deco%20decorative%20elements%2C%20rich%20sepia%20and%20gold%20tones&width=600&height=800&seq=card-04&orientation=portrait',
    tag: '经典',
  },
  {
    title: '动作巨献：燃爆夏日',
    desc: '今夏最炸裂动作大片，实拍特技震撼升级，肾上腺素飙升的观影体验。',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20poster%20with%20explosive%20orange%20and%20gold%20energy%20effects%2C%20silhouetted%20figure%20in%20motion%2C%20dramatic%20low%20angle%20composition%2C%20cinematic%20lighting%20with%20lens%20flares%2C%20intense%20atmosphere%2C%20dark%20background&width=600&height=800&seq=card-05&orientation=portrait',
    tag: '动作',
  },
  {
    title: '治愈系：温暖人心',
    desc: '年度最温暖剧情片，细腻情感直击心灵，观影后久久不能忘怀的感动。',
    img: 'https://readdy.ai/api/search-image?query=Soft%20cinematic%20portrait%20with%20warm%20golden%20sunset%20backlighting%2C%20dreamy%20bokeh%20effect%2C%20gentle%20and%20emotional%20atmosphere%2C%20film%20grain%20texture%2C%20tender%20mood%2C%20pastel%20warm%20tones%2C%20intimate%20composition&width=600&height=800&seq=card-06&orientation=portrait',
    tag: '剧情',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">精选推荐</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          编辑团队精心挑选，每周更新不容错过的优质影片
        </p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {cards.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all cursor-pointer group"
            >
              <div className="relative aspect-[2/3] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">{item.tag}</span>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors truncate mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}